import { render, staticRenderFns } from "./GroupSettingPopup.vue?vue&type=template&id=79d6f179&scoped=true&"
import script from "./GroupSettingPopup.vue?vue&type=script&lang=ts&"
export * from "./GroupSettingPopup.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSettingPopup.vue?vue&type=style&index=0&id=79d6f179&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d6f179",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
